module.exports = __webpack_public_path__ + "tab_chanpin_selected.png?b3a70b9485bd5b98a748f2cb5fb35d48";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_chanpin_selected.png
// module id = 133
// module chunks = 0